// Only the actual parent on an approved origin may control the embedded player.
// Commands establish the parent when Referrer-Policy omits document.referrer.
export function createParentBridge(win, onCommand) {
  const allowed = new Set([
    win.location.origin,
    "https://hltv.org",
    "https://www.hltv.org",
  ]);
  let parentOrigin = null;
  const latest = new Map();
  try {
    const origin = new URL(win.document.referrer).origin;
    if (allowed.has(origin)) parentOrigin = origin;
  } catch {
    /* The verified first command will establish the parent. */
  }
  function send(type, value) {
    latest.set(type, value);
    if (parentOrigin && win.parent !== win)
      win.parent.postMessage({ type, value }, parentOrigin);
  }
  function receive(event) {
    if (
      win.parent === win ||
      event.source !== win.parent ||
      !allowed.has(event.origin) ||
      event.data?.type !== "hltv-demo-command"
    )
      return;
    const first = parentOrigin === null;
    parentOrigin = event.origin;
    onCommand(event.data.action, event.data.value);
    if (first) latest.forEach((value, type) => send(type, value));
  }
  win.addEventListener("message", receive);
  return { send, destroy: () => win.removeEventListener("message", receive) };
}
